import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { DialogConfirmPromptComponent } from './dialog-confirm-prompt.component';

@NgModule({
  imports: [CommonModule, FlexLayoutModule, MatButtonModule, MatDialogModule],
  declarations: [DialogConfirmPromptComponent],
})
export class DialogConfirmPromptModule {}
